var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13Leisure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80518 31.4071C1.40527 30.7406 1.88538 29.8926 2.66267 29.8926H39.1303C39.9076 29.8926 40.3877 30.7405 39.9878 31.4071L35.1878 39.4071C35.0071 39.7083 34.6816 39.8926 34.3303 39.8926H7.46268C7.11141 39.8926 6.7859 39.7083 6.60518 39.4071L1.80518 31.4071Z",
    fill: "#4841A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8965 29.8926H39.1302C39.9075 29.8926 40.3876 30.7406 39.9877 31.4071L36.8789 36.5879L20.3236 32.1052L12.8965 29.8926Z",
    fill: "#353071"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8965 1.02539C19.8965 0.473107 20.3442 0.0253906 20.8965 0.0253906C21.4488 0.0253906 21.8965 0.473106 21.8965 1.02539V30.0254H19.8965V1.02539Z",
    fill: "#4841A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8965 0.892578L36.035 19.8158C36.4599 20.3468 36.2421 21.138 35.6053 21.3768L20.8965 26.8926V0.892578Z",
    fill: "#353071"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8965 1.89258L33.2282 19.9159C33.5777 20.4267 33.3839 21.1291 32.822 21.3885L20.8965 26.8926V1.89258Z",
    fill: "#8F87F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8965 4.89258L11.3645 21.9566C11.1095 22.4665 11.3318 23.0861 11.8528 23.3176L19.8965 26.8926V4.89258Z",
    fill: "#E7E6F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8965 4.89258L19.849 5.91413L18.8933 26.4521L19.8965 26.8926V4.89258Z",
    fill: "#ABA9C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13Leisure);
export default __webpack_public_path__ + "static/media/13_leisure.38ae95b4f8bba760986a46223b8543c6.svg";
export { ForwardRef as ReactComponent };